<script setup>
import { NodeViewWrapper } from '@tiptap/vue-3';
import {
  mentionChipIcon,
  mentionToPanel,
} from 'shared/helpers/copilotMentionContext';

const props = defineProps({
  node: { type: Object, required: true },
  deleteNode: { type: Function, required: true },
  extension: { type: Object, required: true },
});

function handleOpen() {
  const onOpen = props.extension?.options?.onOpen;
  if (!onOpen) return;

  const panel = mentionToPanel({
    type: props.node.attrs.type,
    id: props.node.attrs.id,
    name: props.node.attrs.name,
    portalSlug: props.node.attrs.portalSlug || undefined,
  });
  if (panel) onOpen(panel);
}
</script>

<template>
  <NodeViewWrapper
    as="span"
    class="inline-flex align-middle mx-0.5"
    contenteditable="false"
  >
    <span
      class="group/chip inline-flex items-center gap-1.5 pl-1.5 pr-2.5 py-1 rounded-lg bg-n-solid-3 ring-1 ring-n-weak text-xs max-w-full transition-colors hover:ring-n-brand/50"
      :aria-label="node.attrs.name"
    >
      <button
        type="button"
        class="relative size-3.5 shrink-0 rounded"
        :aria-label="`Remove ${node.attrs.name}`"
        @click.stop="deleteNode()"
      >
        <span
          class="absolute inset-0 text-n-brand transition-opacity group-hover/chip:pointer-events-none group-hover/chip:opacity-0"
          :class="mentionChipIcon(node.attrs.type)"
        />
        <span
          class="i-lucide-x absolute inset-0 text-n-slate-11 opacity-0 transition-opacity group-hover/chip:opacity-100"
        />
      </button>
      <button
        type="button"
        class="max-w-32 truncate text-left text-n-slate-12 cursor-pointer"
        @click.stop="handleOpen"
      >
        {{ node.attrs.name }}
      </button>
    </span>
  </NodeViewWrapper>
</template>
